export const environment = {
  production: false,
  ecatUrl: 'https://q.boschaftermarket.com.cn/ecat_backend/ecat-service/api',
  clientID:"ciamcn_A3D71057-B61A-4334-A6F0-53D0B10F9D05",
  redirectUrl:"https://q.boschaftermarket.com.cn/login",
  userCenterUrl:"https://q.boschaftermarket.com.cn/userCenter",
  userCenterAdminUrl: "https://q.boschaftermarket.com.cn/userCenterAdmin",
  dealerPortalUrl: 'https://q.boschaftermarket.com.cn/dealer_portal',
  requestUrl: "https://q.boschaftermarket.com.cn",
  logoutRequestUrl: 'https://q.boschaftermarket.com.cn/gb/cn',
  changePasswordReturnUrl: 'https://q.boschaftermarket.com.cn', // single key id change password return url
  singleKeyIdToprofile: "https://stage.singlekey-id.com.cn", // 修改用户信息single key id地址
  newsStaticUrl: 'https://news-center.boschaftermarket.com.cn'
};
